module.exports = __webpack_public_path__ + "static/img/home-group6.9809fda8.png";